export default __webpack_public_path__ + "static/media/2-Ano-03-LocalizandoSe-Nos-Ambientes.7861dbc5.png";